<template>
    <div :class="$style.cardbox">
        <b-card
            no-body
            border-variant="success"
            bg-variant="transparent"
            class="text-center"
        >
            <b-card-header header-bg-variant="success">
                {{ $t(levels[0].title) }} <font-awesome-icon icon="star" v-for="n in 3" :key="n"></font-awesome-icon>
            </b-card-header>

            <b-card-body>
                <ul class="card-text">
                    <li v-for="sub in levels[0].subs" :key="sub">{{ $t(sub) }}</li>
                </ul>
            </b-card-body>
        </b-card>

        <b-card
            no-body
            border-variant="warning"
            bg-variant="transparent"
            class="text-center"
        >
            <b-card-header header-bg-variant="warning" header-text-variant="dark">
                {{ $t(levels[1].title) }} <font-awesome-icon icon="star" v-for="n in 2" :key="n"></font-awesome-icon>
            </b-card-header>

            <b-card-body>
                <ul class="card-text">
                    <li v-for="sub in levels[1].subs" :key="sub">{{ $t(sub) }}</li>
                </ul>
            </b-card-body>
        </b-card>

        <b-card
        no-body
            border-variant="danger"
            bg-variant="transparent"
            class="text-center"
        >
            <b-card-header header-bg-variant="danger">
                {{ $t(levels[2].title) }} <font-awesome-icon icon="star" v-for="n in 1" :key="n"></font-awesome-icon>
            </b-card-header>

            <b-card-body>
                <ul class="card-text">
                    <li v-for="sub in levels[2].subs" :key="sub">{{ $t(sub) }}</li>
                </ul>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import bCard from 'bootstrap-vue/es/components/card/card';
import bCardHeader from 'bootstrap-vue/es/components/card/card-header';
import bCardBody from 'bootstrap-vue/es/components/card/card-body';
export default {
    components: {
        bCard,
        bCardHeader,
        bCardBody
    },
    computed: {
        levels () {
            return this.$root.shared.economyLevels;
        }
    }
};
</script>

<style module lang="scss" scoped>
    .cardbox {
        @media(min-width: 40em) {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-column-gap: 1em;
        }
    }

    .cardbox > * {
        margin-bottom: 1em;
    }

    ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }
</style>
